import { render, staticRenderFns } from "./OjtMaExport.vue?vue&type=template&id=423861a5"
import script from "./OjtMaExport.vue?vue&type=script&lang=js"
export * from "./OjtMaExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports